import { Button, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ShareLinkDropdown = styled.div`
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: var(--size-16);
  width: 266px;
`;

const ShareCopy = styled.div`
  button {
    text-transform: uppercase;
  }
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const ShareLinksSeeMore = styled(Button)`
  margin: 8px 0;
`;

const TextLabel = styled(Typography)`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const ShareLinks = styled.div`
  display: flex;
  flex-direction: column;
`;

const ShareLink = styled.a`
  align-items: center;
  color: var(--color-neutral-800);
  display: flex;
  gap: 16px;
  padding: 8px;

  &:hover {
    background-color: var(--color-gray-50);
  }
`;

const ShareLinkText = styled.div``;

export {
  Header,
  ShareCopy,
  ShareLink,
  ShareLinkDropdown,
  ShareLinkText,
  ShareLinks,
  ShareLinksSeeMore,
  TextLabel
};
